/* eslint-disable react-hooks/exhaustive-deps */
import { withRouter } from "../_shared/withRouter";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../template/_common/header";
import SidebarComponent from "../template/admin/sidebarComponent";
import SidebarArrow from "../template/_common/sidebarArrow";
import { Helmet } from "react-helmet";
import { globalAlert, globalLoader } from "../actions/commonActions";
import { physicalCardReportApi } from "./_actions";
import PhysicalCardReportTable from "../template/admin/physicalCardReportTable";
import { compareValues, logOut } from "../_shared/commonFunction";
import { addDays } from "date-fns";
import arraySort from "array-sort";
import Reports from "../template/admin/reports";

const PhysicalCardReport = (props) => {
  const { t } = useTranslation();
  const [navbarToggle, setNavbarToggle] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [currentReportList, setCurrentReportList] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [sortObj, setSortObj] = useState({});
  const [searchVal, setSearchVal] = useState("");
  const [filterType, setFilterType] = useState("all");

  const handleSidebar = (data) => {
    setNavbarToggle(data);
  };

  const callBasicApi = async (val = null) => {
    globalLoader(true);
    try {
      let query = val
        ? val
        : `dateFrom=${addDays(new Date(), -30).toISOString()}&dateTo=${new Date().toISOString()}`;
      // Request large page to get all data for client-side search/sort
      if (!query.includes("pageSize")) {
        query += "&pageSize=1000";
      }
      const res = await physicalCardReportApi(query);
      if (res?.data?.status === 200) {
        setSearchVal("");
        const report = res?.data?.data?.report || [];
        setReportData(report);
        setTotalCount(res?.data?.data?.total || report.length);
        filteredDataFunc(report, 1);
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalAlert("error", error?.response?.data?.message);
      if (error?.response?.data?.status === 401) {
        logOut(props?.history, "/admin/login");
      }
      globalLoader(false);
    }
  };

  useEffect(() => {
    filteredDataFunc();
  }, [pageSize, currentPage, sortObj, searchVal]);

  const filteredDataFunc = (dataArray = null, localPage = null) => {
    let arr = dataArray || [...reportData];

    if (!dataArray) {
      arr = arraySort(arr, compareValues(sortObj?.sortVal), {
        reverse: sortObj?.sortType === "desc",
      });
    }

    if (searchVal.length > 0) {
      arr = arr.filter((data) => {
        return (
          data?.cardIdentifier
            ?.toLowerCase()
            .includes(searchVal.toLowerCase()) ||
          data?.storeName?.toLowerCase().includes(searchVal.toLowerCase()) ||
          data?.userName?.toLowerCase().includes(searchVal.toLowerCase()) ||
          data?.productName?.toLowerCase().includes(searchVal.toLowerCase())
        );
      });
    }

    setTotalCount(arr.length);

    const page = localPage || currentPage;
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    setCurrentReportList(arr.slice(start, end));
  };

  const arraySorting = (val) => {
    let sortType = "aesc";
    if (val === sortObj?.sortVal && sortObj?.sortType === "aesc") {
      sortType = "desc";
    }
    setSortObj({ sortVal: val, sortType });
  };

  const changePageSizeFunc = (val) => {
    setPageSize(val.target.value);
    setCurrentPage(1);
  };

  const goToPageFunc = (val, data) => {
    if (data === "prev" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else if (
      data === "next" &&
      currentPage < Math.ceil(totalCount / pageSize)
    ) {
      setCurrentPage(currentPage + 1);
    } else if (val?.target?.value) {
      setCurrentPage(Number(val.target.value));
    }
  };

  return (
    <div className="admin-portal">
      <Helmet>
        <title>{t("admin.pageTitle.physicalCardsReport")} - eC-Card</title>
        <meta name="viewport" content="width=1200, initial-scale=1" />
      </Helmet>
      <Header roleType="admin" />
      <div className={`${navbarToggle ? "active" : ""} wrapper`}>
        <SidebarComponent
          navbarToggle={navbarToggle}
          active={props.match.path}
          menu="reports"
          subMenu="physical-cards-report"
        />
        <div className="main">
          <div className="main-wrapper">
            <div>
              <p className="admin-banner">
                {t("admin.physicalCards.report.title")}
              </p>
            </div>
            <SidebarArrow handleSidebarToggle={handleSidebar} />

            <Reports
              type="stores"
              searchTable={callBasicApi}
              filterType={filterType}
              changeFilterType={setFilterType}
            />

            {currentReportList?.length > 0 ? (
              <PhysicalCardReportTable
                reportData={currentReportList}
                pageSize={pageSize}
                changePageSize={changePageSizeFunc}
                goToPage={goToPageFunc}
                totalCount={totalCount}
                currentPage={currentPage}
                arraySorting={arraySorting}
                sortObj={sortObj}
                allReport={reportData}
                searchVal={searchVal}
                setSearchVal={setSearchVal}
              />
            ) : (
              <div className="px-3 pt-3">
                <div className="no-data-available">
                  {t("common.noDataAvailable")}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(PhysicalCardReport);
